

















































































import { PropertyData } from '@beyondview/firebase-client-8';
import { mapGetters } from 'vuex';
import mapboxgl from 'mapbox-gl';
import Vue, { PropType } from 'vue';
import { MetaInfo } from 'vue-meta';

import { locationTitle } from '@/filters';

import PropertyImages from '@/components/property/PropertyImages.vue';
import ClipboardButton from '@/components/ClipboardButton.vue';
import ChangePropertyLocationModal from '@/components/modals/ChangePropertyLocationModal.vue';
import MapboxMap from '@/components/MapboxMap.vue';

interface ComponentData {
	marker: mapboxgl.Marker | null,
	map: mapboxgl.Map | null
}

export default Vue.extend( {
	components: {
		PropertyImages,
		ClipboardButton,
		ChangePropertyLocationModal,
		MapboxMap
	},
	props: {
		property: {
			type: Object as PropType<PropertyData>,
			required: true
		}
	},
	data(): ComponentData {
		return {
			marker: null,
			map: null
		};
	},
	head(): MetaInfo {
		return {
			title: `${this.$t( 'views.property.location.location' )}`
		};
	},
	computed: {
		...mapGetters( [ 'userIsAdmin' ] ),
		googleMapsUrl() {
			const query = locationTitle( this.property.location );
			return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent( query )}`;
		}
	},
	watch: {
		[ 'property.location.point' ]() {
			this.updateMarker();
		}
	},
	methods: {
		async showChangePropertyLocationModal() {
			await ( this.$refs as any ).changePropertyLocationModal.show( this.property );
		},
		initMap( map: mapboxgl.Map ) {
			this.map = map;
			this.updateMarker();
		},
		updateMarker() {
			// Clean up old marker
			if ( this.marker ) {
				this.marker.remove();
			}

			if ( this.property.location.point && this.map ) {
				const { latitude: lat, longitude: lon } = this.property.location.point;
				this.marker = new mapboxgl.Marker( { color: '#4180d8' } )
					.setLngLat( [ lon, lat ] )
					.addTo( this.map );
				this.map.setCenter( [ lon, lat ] );
				this.map.setZoom( 7 );
				this.map.setPadding( { top: 75 } as mapboxgl.PaddingOptions );
			}
		}
	}
} );
